import React from "react";

// Словник для назв кнопок-фільтрів
const subjectTypeMap = {
  exclusion_price: "Ціни (виключення)",
};

// Словник для назв дій
const actionTypeMap = {
  exclusion_price_updated: "Оновив(ла) ціну",
  exclusion_price_created: "Додав(ла) виключення",
  exclusion_price_deleted: "Видалив(ла) виключення",
};

// Словник для назв полів у 'properties'
const propertyKeyMap = {
  new_price: "Ціна",
};

/**
 * Спеціальна функція-рендер для відображення 'properties'.
 */
const renderPropertyChanges = (properties) => {
  const { new_values, old_values, deleted_values } = properties;

  // Оновлення або створення
  if (new_values) {
    const key = "new_price";
    const friendlyName = propertyKeyMap[key] || key;

    // Якщо є old_values (це оновлення)
    if (old_values && old_values[key] !== undefined) {
      return (
        <ul className="history-item__changes">
          <li>
            <strong>{friendlyName}: </strong>
            <span className="old-value">{old_values[key] || "пусто"}</span>
            <span> → </span>
            <span className="new-value">{new_values[key] || "пусто"}</span>
          </li>
        </ul>
      );
    }

    // Якщо НЕМАЄ old_values (це створення)
    return (
      <ul className="history-item__changes">
        <li>
          <strong>{friendlyName}: </strong>
          <span className="new-value">{new_values[key] || "пусто"}</span>
        </li>
      </ul>
    );
  }

  // Видалення
  if (deleted_values) {
    const key = "new_price";

    if (deleted_values[key] === null || deleted_values[key] === undefined) {
      return null;
    }

    return (
      <ul className="history-item__changes deleted">
        <li>
          <strong>{propertyKeyMap[key] || key}: </strong>
          <span className="deleted-value">{deleted_values[key]}</span>
        </li>
      </ul>
    );
  }

  return null;
};

export const exclusionHistoryConfig = {
  subjectTypeMap,
  actionTypeMap,
  renderPropertyChanges,
};
